import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import { CreateTicketData, Endereco } from 'src/app/api';
import {maskString, TextFormats} from '@mandae/ng-utils/mask';
import {from, Subject} from 'rxjs';
import {filter, map, switchMap, tap} from 'rxjs/operators';
import {PedidoService} from '../../../services/ajs-pedido.service';
import {PerfilService} from '../../../services/ajs-perfil.service';
// import {AtendimentoService} from '../../../services/ajs-atendimento.service';
import {AddressFormComponent} from '../address-form/address-form.component';
import { AtendimentoApiService } from 'src/app/services/ajs-atendimento.service';

@Component({
  selector: 'mandae-address-checkin-button',
  templateUrl: './address-checkin-button.component.html',
  styleUrls: ['./address-checkin-button.component.scss']
})
export class AddressCheckinButtonComponent implements OnInit, OnDestroy {

  @Input() pkg;
  @Output() error = new EventEmitter<string>();
  @Output() success = new EventEmitter<string>();

  public disableButtons = false;

  private createTicketSubject = new Subject<any>();

  constructor(
    private dialog: MatDialog,
    private perfil: PerfilService,
    private pedidoService: PedidoService,
    private relationshipApi: AtendimentoApiService,
  ) {
  }

  ngOnInit() {
    this.createTicketSubject
      .pipe(
        tap(() => this.disableButtons = true),
        switchMap(data =>
          from(this.pedidoService.updateEndereco(this.pkg.id, data.address))
            .pipe(
              switchMap(() => this.relationshipApi.atualizarAtendimento(this.makeTicketData(data.comment))),
              tap(() => {
                this.success.emit(data.successMessage);
              }),
            )),
        tap(() => {
          this.disableButtons = false;
        }),
      )
      .subscribe(() => {
      }, () => {
        this.disableButtons = false;
        this.error.emit('Houve um erro ao corrigir a encomenda, por favor, tente novamente mais tarde.');
      });
  }

  ngOnDestroy() {
    this.createTicketSubject.complete();
  }

  openAddressFormDialog($event: Event) {
    $event.preventDefault();

    const dialogRef = this.dialog.open(AddressFormComponent, {
      disableClose: true,
      hasBackdrop: true,
      width: '600px',
      maxWidth: '95vw',
      closeOnNavigation: true,
      data: {
        address: this.pkg.destinatario.endereco
      }
    });

    dialogRef
      .afterClosed()
      .pipe(
        filter(result => result !== null),
        map(result => this.mapNewAddress(result)),
        tap(data => this.createTicketSubject.next(data)),
      )
      .subscribe();
  }

  makeTicketData(comment: string): CreateTicketData {
    return {
      comment: comment || 'Divergência respondida',
      tags: ['origem-paineldeocorrencias'],
      trackingCode: this.pkg.rastreamento.codigoMandae,
      subject: this.pkg.rastreamentoRemessa.descricaoEvento,
      divergenceType: this.pkg.rastreamentoRemessa.descricaoEvento,
      occurrenceType: this.pkg.rastreamentoRemessa.descricaoEvento,
    };
  }

  private mapNewAddress(address: any) {
      if (address && address !== undefined) {
        const mappedAddress: any = {
          bairro: address.district,
          cep: address.postalCode.replace(/\D/g, ''),
          cidade: address.city,
          codigoPostal: address.postalCode.replace(/\D/g, ''),
          complemento: address.complement,
          estado: address.state,
          logradouro: address.street,
          numero: address.number,
          pais: 'Brasil',
          uf: address.state,
        };

        try {
          const comment = this.createCommentForNewAddress(address.observation, mappedAddress);

          return {
            comment,
            address: mappedAddress,
            successMessage: 'Endereço atualizado com sucesso!',
          };
        } catch (err) {
          this.error.emit('Houve um erro ao corrigir a encomenda, por favor, tente novamente mais tarde.');
        }
      } else {
        return;
      }
  }

  private createCommentForNewAddress(comment: string, address: any) {
    return `Alteração de endereço da encomenda

Endereço antigo:
${this.formatAddress(this.pkg.destinatario.endereco)}

Novo endereço:
${this.formatAddress(address)}

Observação:
${comment}
`;
  }

  private formatAddress(address: Partial<Endereco>) {
    const lines = [
      [address.logradouro, address.numero, address.complemento].filter(part => !!part).join(', '),
      [address.bairro, address.cidade, address.uf, address.pais].filter(part => !!part).join(' - '),
      maskString(address.cep, TextFormats.cepMask),
    ];
    return lines.join('\n');
  }
}
